export const REPORTS_TYPES = ['cost', 'revenue'];

export const TIMEOFF_TABLE_COLUMN_HEADERS = {
  fullLegalName: 'legal name',
  type: 'type',
  requestedMinutes: 'requested hours',
  requestedDays: 'requested days',
  approvedMinutes: 'approved hours',
  approvedDays: 'approved days',
  unpaidMinutes: 'unpaid hours',
  unpaidDays: 'unpaid days',
  deniedMinutes: 'denied hours',
  deniedDays: 'denied days',
  ptoCost: 'cost',
  remaining: 'remaining',
};

export const TIMEOFF_TABLE_COLUMN_DESCRIPTIONS = {
  fullLegalName: 'Legal name',
  type: 'Type',
  requestedMinutes: 'Requested hours',
  requestedDays: 'Requested days',
  approvedMinutes: 'Approved hours',
  approvedDays: 'Approved days',
  unpaidMinutes: 'Unpaid hours',
  unpaidDays: 'Unpaid days',
  deniedMinutes: 'Denied hours',
  deniedDays: 'Denied days',
  ptoCost: 'Cost',
  remaining: 'Remaining',
};

export const ICELANDIC_PAYROLL_CODES = {
  SALARIED_CODE: '100',
  SALARIED_SICK_CODE: '232',
  SALARIED_SICK_CHILD_CODE: '234',
  REGULAR_CODE: '101',
  MONTH_OVERTIME_CODE: '102',
  EVENING_CODE: '110',
  MORNING_AND_WEEKEND_CODE: '111',
  REGULAR_SICK_CODE: '221',
  REGULAR_SICK_CHILD_CODE: '222',
  EVENING_SICK_CODE: '223',
  EVENING_SICK_CHILD_CODE: '235',
  MORNING_AND_WEEKEND_SICK_CODE: '231',
  MORNING_AND_WEEKEND_SICK_CHILD_CODE: '236',
};

export const SHIFT_FEEDBACK_TABLE_COLUMN_DESCRIPTIONS = {
  preferredName: 'Preferred Name',
  date: 'Date',
  employeeId: 'Employee ID',
  location: 'Location',
  position: 'Position',
  groups: 'Groups',
  tags: 'Tags',
  dayPart: 'Day Parts',
  shift: 'Shift',
  rating: 'Rating',
  comment: 'Comment',
};

export const SHIFT_FEEDBACK_TABLE_COLUMN_HEADERS = {
  preferredName: 'Preferred Name',
  date: 'Date',
  employeeId: 'Employee ID',
  location: 'Location',
  position: 'Position',
  groups: 'Groups',
  tags: 'Tags',
  dayPart: 'Day Parts',
  shift: 'Shift',
  rating: 'Rating',
  comment: 'Comment',
};
